// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event Property Definition: https://pap.pp.dropbox.com/#/event_property/2931

import type { DashProfilingTeamSize } from "./dash_profiling_team_size";

const DashProfilingTeamSizeValues: DashProfilingTeamSize[] = [
    "just_me",
    "size_2_19",
    "size_20_99",
    "size_100_249",
    "size_250_1000",
    "size_1000_plus",
];

export function getDashProfilingTeamSizeFromString(s: string): DashProfilingTeamSize | undefined {
    return DashProfilingTeamSizeValues.find(e => e === s?.toLowerCase());
}
